
/* styles */
require("!!vue-style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-737524f4&scoped=true!sass-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PageForm.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PageForm.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-737524f4!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PageForm.vue"),
  /* scopeId */
  "data-v-737524f4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/page/partials/PasswordRemindForm/PageForm.vue
// module id = 642
// module chunks = 0